import { html } from "lit";
var icon_save_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 28">
    <g transform="rotate(-180 12.675 13.5)">
      <path
        d="M22.384-.528H2.316c-1.398 0-2.6 1.002-2.6 2.342v22.128c0 1.34 1.202 2.342 2.6 2.342h15.611a2.776 2.776 0 001.765-.62l4.522-4.42c.462-.379.77-1 .77-1.664V1.814c0-1.34-1.202-2.342-2.6-2.342zm0 2.112c.308 0 .488.15.488.23V19.58c0 .018-.016.052-.07.097l-4.523 4.42-.026.012a.88.88 0 01-.244.058l-.101.005H2.316c-.308 0-.488-.15-.488-.23V1.814c0-.08.18-.23.488-.23h20.068z" />
      <rect x="3.9" y="19.5" width="5.2" height="6.5" rx="1.3" />
      <path
        d="M17.55-.3H7.15A2.3 2.3 0 004.85 2v8.4a2.3 2.3 0 002.3 2.3h10.4a2.3 2.3 0 002.3-2.3V2a2.3 2.3 0 00-2.3-2.3zm-10.4 2h10.4a.3.3 0 01.3.3v8.4a.3.3 0 01-.3.3H7.15a.3.3 0 01-.3-.3V2a.3.3 0 01.3-.3z" />
    </g>
  </svg>
`;
export {
  icon_save_default as default
};
//# sourceMappingURL=icon-save.js.map
